import CSVPreviewSection from '../CSVPreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function ProfitLossCSVPreviewGroupingSection(){}

ProfitLossCSVPreviewGroupingSection.prototype = new CSVPreviewSection();

ProfitLossCSVPreviewGroupingSection.prototype.init = function(firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, countDataColumns, countGroupingColumns){
    CSVPreviewSection.prototype.init.call( this );
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.countDataColumns = countDataColumns;
    this.countGroupingColumns  = countGroupingColumns;
    return this;
};

ProfitLossCSVPreviewGroupingSection.prototype.addRows = function ( tBody )
{
    for( var i = 0; i < 5; i++ )
    {
        var row = this.createRow();
        this.addGroupingLevel(row,this.firstGroupingLevel);
        if( this.secondGroupingLevel != ReportGroupingLevel.NONE )
            this.addGroupingLevel(row,this.secondGroupingLevel);
        if( this.thirdGroupingLevel != ReportGroupingLevel.NONE )
        {
            this.addGroupingLevel( row, this.thirdGroupingLevel );
            this.addCell(row, this.message("report.billing_type"));
        }

        for( var j = 0; j < this.countDataColumns; j++ )
            this.addTimeValueCell( row );
        this.addRow( tBody, row );
    }
};

ProfitLossCSVPreviewGroupingSection.prototype.addGroupingLevel = function(row, groupingLevel){
    ReportPreviewUtils.addCell( row, ReportPreviewUtils.getLevelPreviewName(groupingLevel ) );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/profitloss/ProfitLossCSVPreviewGroupingSection.js